import React from "react";
import { Globe } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function LanguageSwitcher() {
  const { lang, setLang, languages } = useI18n();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          className="flex items-center gap-1 rounded-full px-2.5 py-2 text-[#4A6358] transition-colors hover:bg-[#F0F4F1] active:scale-95"
        >
          <Globe size={18} />
          <span className="text-xs font-bold uppercase">{lang}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[9rem]">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-switch-${l.code}`}
            onClick={() => setLang(l.code)}
            className={lang === l.code ? "font-semibold text-[#2D5A4C]" : ""}
          >
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
